<template>
  <div class="layout2" style="background: #f2f5f7">
    <div class="myff" style="background: #fff">
      <div class="myffTit">评分等级</div>
      <markbox :item="row" style="margin-top: 60px"></markbox>
    </div>
    <div class="peaceTab2 mytabTT1">
      <div
        class="intes-bt-box"
        v-show="row.son.length !== 0"
        style="padding: 0 15px"
      >
        <noZklist :list="row.son"></noZklist>
      </div>

      <div v-show="row.son.length == 0" style="text-align: center">
        暂无数据
      </div>
    </div>
    <ball :text="'返回'"></ball>
  </div>
</template>
<script>
import noZklist from "./components/noZklist.vue"
import markbox from "./components/markBox.vue"
import ball from "./components/ball.vue"
export default {
  components: {
    noZklist, markbox, ball
  },
  data () {
    return {
      activeNames: [],
      row: {},
    }
  },
  created () {
    this.row = JSON.parse(decodeURIComponent(this.$route.query.row))
    document.title = this.row.name
    console.log(this.row)

  },
  methods: {

  }
}
</script>
<style lang="scss" >
.myff {
  padding: 0.16rem 0.21333rem;
  color: #969799;
  font-size: 0.18667rem;
  line-height: 1.5;
  background-color: #fff;
  margin-top: 38px !important;
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  margin: 0 30px;
  .myffTit {
    text-align: center;
    font-size: 24px;
    color: #333;
    margin-top: 20px;
  }
}
.peaceTab2 {
  padding-top: 30px;
  .van-cell {
    padding: 30px 20px !important;
    font-size: 30px !important;
  }
  .van-collapse-item--border::after {
    border-color: #e3e1e1;
  }
  .van-tabs__nav--card {
    height: 100px !important;
    .van-tab {
      width: 160px !important;
      height: 60px !important;
      background: #e1f1ff;
      box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3);
      border-radius: 30px;
      margin-right: 20px;
      padding: 0 !important;

      flex: 0 0 24% !important;
    }
  }
  .van-cell__value {
    padding-top: 20px;
    font-size: 26px;
    flex: 0.5;
    padding-right: 20px;
  }
  .van-cell__right-icon {
    margin-top: 20px !important;
  }
  .van-tab__text {
    font-size: 28px;
  }
  .van-tab--active {
    width: 160px !important;
    height: 60px !important;
    background: #008def !important;

    box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3) !important;
    border-radius: 30px !important;
  }
  .van-tabs__wrap {
    height: 100px !important;
  }
  .van-tabs__nav {
    background: none;
    border: none;
  }
  .van-tabs__content--animated {
    padding-top: 0;
  }
}
.mytabTT1 {
  // .van-cell__right-icon {
  //   margin-top: 0px !important;
  // }
  // .van-cell__value {
  //   padding-top: 0px !important;
  // }
}
</style>